import { createApp } from "vue";
import App from "./App.vue";
import VueGoogleMaps from "vue-google-maps-community-fork";
import { createI18n } from "vue-i18n";
// @ts-ignore
import fi from "@/locales/fi.json";
// @ts-ignore
import et from "@/locales/ee.json";
// @ts-ignore
import en from "@/locales/en.json";
import "@/scss/element/index.scss";
import "@/scss/styles.scss";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

const lang = document.documentElement.lang.split("_")[0] ?? "fi";

const i18n = createI18n({
  legacy: false,
  locale: lang,
  fallbackLocale: "fi",
  availableLocales: ["fi", "et", "en"],
  messages: {
    fi,
    et,
    en,
  },
});

// Get all data-attributes from the element, and pass them to the app.
const dataAttributes = (document.querySelector("#app") as HTMLElement | undefined)?.dataset
const props: Record<string, any> = {}
if (dataAttributes) {
  for (const key in dataAttributes) {
    props[key] = dataAttributes[key]
  }
}

const app = createApp(App, props);
app.use(i18n);
app.use(ElementPlus);
app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDVkgtCKxbIBuYwhbVswaf8yjSSja0gXyQ", //@TODO API key, will be changed. Or will it?
    libraries: "places,geometry", // Library necessary for autocomplete inputs
  },
});
app.mount("#app");
